import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { getFlyingBetslipConfig } from 'helpers/prematch';

import { constants } from '@atlas/core';
import { Button, EmptyStateView } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';
import DetailsMarketType from 'components/Pages/Details/DetailsMarketType';

const {
  STATUS: { HIDDEN },
} = constants;

const DetailsMarketTypesList = ({
  event,
  expandedMarketTypes,
  handleSetShrinkMarketTypes,
  isEventDisabled,
  processedMarketTypes,
  selectFavoriteMarketType,
  suspended,
}) => {
  const { results, sportLive, sportPrematch } = defaultRoutes;
  const { pathname } = useLocation();

  const detailsMarketListClass = React.useMemo(
    () =>
      cx('details-event-markets-list', {
        'details-event-markets-list-with-extended-betslip': getFlyingBetslipConfig().hasExtended,
      }),
    [],
  );

  const NoMarketsView = React.useMemo(
    () => (
      <EmptyStateView
        className="empty-center"
        description="markets_empty_message."
        title="markets_empty_title"
      >
        <div className="sticky-bottom-buttons-container column button-no-markets">
          <Link aria-label="Prematch" to={sportPrematch}>
            <Button className="btn big secondary " label="go_to_sport" />
          </Link>

          <Link aria-label="Live" to={sportLive}>
            <Button className="btn big primary" label="go_to_live" />
          </Link>
        </div>
      </EmptyStateView>
    ),
    [sportLive, sportPrematch],
  );

  if (processedMarketTypes.length === 0 && `/${pathname.split('/')[1]}` === results) {
    return (
      <EmptyStateView
        className="empty-state-view"
        description="markets_empty_message"
        title="markets_empty_title"
      />
    );
  }

  if (event.status === HIDDEN) {
    return NoMarketsView;
  }

  if (processedMarketTypes.length === 0 && `/${pathname.split('/')[1]}` !== results) {
    return NoMarketsView;
  }

  return (
    <div className={detailsMarketListClass}>
      {processedMarketTypes?.map(({ data, isFavorite }) => {
        return (
          <DetailsMarketType
            disabled={isEventDisabled}
            event={event}
            expandedMarketTypes={expandedMarketTypes}
            isFavorite={isFavorite}
            key={data.id}
            marketType={data}
            selectFavoriteMarketType={selectFavoriteMarketType}
            setExpandedMarketTypes={handleSetShrinkMarketTypes}
            suspended={suspended}
          />
        );
      })}
    </div>
  );
};

export default DetailsMarketTypesList;
